import React, { Component } from "react";
import Slider from "@mui/material/Slider";
import { Box, FormControl, MenuItem, Select, Switch } from "@mui/material";
import Header from "../../header";

class CarFiltering extends Component {
  getFilterValue = (filterId) => {
    const value = this.props.features.find(
      (feature) => feature.id === filterId,
    );
    return value?.value || "";
  };

  render() {
    const {
      filter,
      changePriceRange,
      handleStock,
      stock,
      applyFilter,
      price,
      handleModal,
      clearFilter,
      checkForNumric,
      checkForText,
      defaultPrice,
      addFilter,
    } = this.props;
    return (
      <>
        <div className="carFiltering">
          <Header
            showSearchBar={true}
            title="فیلتر بندی"
            backHandler={() => handleModal()}
          />
          <div className="carFilterSections">
            <div className="carFilterBox">
              {filter.map((filter, index) =>
                filter.type === 2 ? (
                  <Box key={index}>
                    <label>{filter.feature}</label>
                    <FormControl>
                      <Select
                        value={this.getFilterValue(filter.id)}
                        onChange={(e) => addFilter(filter.id, e.target.value)}
                        displayEmpty
                      >
                        <MenuItem value="">مهم نیست</MenuItem>

                        {filter.list.map((filter, index) => (
                          <MenuItem value={filter} key={index}>
                            {filter}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                ) : (
                  <div className="filterInput">
                    <label>{filter.feature}</label>
                    <input
                      type="text"
                      placeholder="مهم نیست"
                      onChange={
                        filter.type === 1
                          ? (e) => checkForNumric(filter.id, e.target.value)
                          : (e) => checkForText(filter.id, e.target.value)
                      }
                    />
                  </div>
                ),
              )}
            </div>

            <div className="carFilterSliderBox">
              <label>قیمت</label>
              <Slider
                min={defaultPrice[0]}
                max={defaultPrice[1]}
                onChange={changePriceRange}
                value={[price[0], price[1]]}
                className="priceRangeSlider"
              />

              <div className="priceRangeNum">
                <span>{price[1].toLocaleString()} تومان</span>
                <span>{price[0].toLocaleString()} تومان</span>
              </div>
            </div>
            <div className="carFilterBox">
              <div className="carFilterSwitch">
                <label>اجناس موجود</label>
                <Switch
                  value={stock}
                  onChange={handleStock}
                  className="filterSwitch"
                  color="default"
                />
              </div>
            </div>
            <div className="carFilterBtnSection">
              <button
                className="carFilterClearBtn"
                onClick={() => {
                  clearFilter();
                }}
              >
                حذف فیلتر
              </button>
              <button
                className="carFilterBtn"
                onClick={() => {
                  applyFilter();
                }}
              >
                اعمال فیلتر
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default CarFiltering;
